import Customer from 'src/models/customer.js';

class CustomerMedicalSelectionAcceptanceDetails {
  constructor(params) {
    this.customer = new Customer(params.customer);
    this.packageName = params.packageName;
    this.isApproved = params.isApproved;
  }
}
export { CustomerMedicalSelectionAcceptanceDetails as default };
